const gridStyles = {
    firstName: {
        gridSize: {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    lastName: {
        gridSize: {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    emailAddress: {
        gridSize: {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    phoneNumber: {
        gridSize: {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    address: {
        gridSize: {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    unit: {
        gridSize: {
            xs: 6,
            sm: 2,
            md: 2,
            lg: 2,
            xl: 2,
        },
    },
    city: {
        gridSize: {
            xs: 6,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4,
        },
    },
    state: {
        gridSize: {
            xs: 6,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    zip: {
        gridSize: {
            xs: 6,
            sm: 6,
            md: 6,
            lg: 6,
            xl: 6,
        },
    },
    hearAboutUs: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
        },
    },
    uploadFile: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
        },
    },
    propertyType: {
        gridSize: {
            xs: 12,
            sm: 7,
            md: 7,
            lg: 7,
            xl: 7,
        },
    },
    houseSize: {
        gridSize: {
            xs: 12,
            sm: 7,
            md: 7,
            lg: 7,
            xl: 7,
        },
    },
    existingThermostat: {
        gridSize: {
            xs: 12,
            sm: 7,
            md: 7,
            lg: 7,
            xl: 7,
        },
    },
    installedOn: {
        gridSize: {
            xs: 12,
            sm: 7,
            md: 7,
            lg: 7,
            xl: 7,
        },
    },
    termsAndConditions: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
        },
    },
    acknowledgement: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
        },
    },
    rebateReceiver: {
        gridSize: {
            xs: 12,
            sm: 7,
            md: 7,
            lg: 7,
            xl: 7
        } 
    },
    receiverAccountType: {
        gridSize: {
            xs: 12,
            sm: 5,
            md: 5,
            lg: 5,
            xl: 5
        } 
    },
    dateNotes: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
        } 
    },
    scheduleAppointment: {
        gridSize: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
        } 
    },
    validateSummarySizes: {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        xl: 6,
    },
    payeeSummarySizes: {
        xs: 12,
        sm: 3,
        md: 3,
        lg: 3,
        xl: 3,
    },
    eligibilitySummarySizes: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
    }
};

export default gridStyles;
